import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import App from './App';
import "./index.css";
import Main from './layout/Main';
import Durbinnews from './pages/Durbinnews';
import EcommercePlatform from './pages/EcommercePlatform';
import Reluxrent from './pages/Reluxrent';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Main/>,
    children:[
      {
        path: "/",
        element: <App/>,
      },
      {
        path: "/durbinnews",
        element: <Durbinnews/>,
      },
      {
        path: "/ecommerce-platform",
        element: <EcommercePlatform/>,
      },
      {
        path: "/reluxrent",
        element: <Reluxrent/>,
      },
    ]
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
